// @flow

import { Component } from 'react';
import type { Node } from 'react';
import { HeadContentService } from 'shared_services/riseart/HeadContent';
import { isPromise } from 'shared_services/riseart/utils/Utils';
import { findCmsModule } from 'shared_components/cms/utils';

type Props = {
  placeholderName: string,
  moduleLoader: Function,
  placeholders: Array<Object>,
  children?: Node,
};

/**
 * CmsHeadContentRenderer
 *
 * @param {Props} props
 * @returns {Node}
 */
export class CmsHeadContentRenderer extends Component<Props> {
  static defaultProps: Object;

  /**
   * constructor
   *
   * @param {Props} props
   */
  constructor(props: Props) {
    super(props);

    this.addHeadContent();
  }

  /**
   * componentWillUnmount
   */
  componentWillUnmount() {
    HeadContentService.detach();
  }

  componentDidUpdate(prevProps: Props) {
    const prevModule = findCmsModule(prevProps.placeholders, prevProps.placeholderName);
    const currentModule = findCmsModule(this.props.placeholders, this.props.placeholderName);

    if (currentModule && prevModule && currentModule.content !== prevModule.content) {
      HeadContentService.detach();

      this.addHeadContent();
    }
  }

  addHeadContent() {
    const headPromise = this.props.moduleLoader(this.props.placeholderName, { loadModule: true });

    // Check if promise exists first, because it might be that the placeholder module is not listed in placeholders list
    if (isPromise(headPromise))
      headPromise.then((componentInstance) => {
        if (componentInstance) {
          HeadContentService.add(componentInstance);
        }
      });
  }

  /**
   * render
   *
   * @returns {Node}
   */
  render(): Node {
    return this.props.children || null;
  }
}
